import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options, label }) {
    return (
        <div className="ns-selection-dropdown ns-relative ns-d-inline-flex ns-align-items-center body-l text-t-brand-foreground-secondary">
            <span>Sort:</span>
            <div class="ns-relative cursor-pointer transition-[color] duration-300 ease-out hover:text-t-brand-foreground">
                <select
                    className={`ns-selection-dropdown-menu ns-text-align-left ${className}`}
                    value={value}
                    onChange={onChange}
                    aria-label={label || "Select"}
                >
                    {options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <div class="ns-absolute top-1/2 right-0 -translate-y-1/2">
                    <svg width="10" height="10" aria-hidden='true' focusable='false' role='presentation' class='icon icon-caret' viewBox='0 0 10 10' fill='none'>
                        <path d="M9.58337 2.9165L5.00004 6.92692L0.416707 2.9165" stroke="currentColor" stroke-width="0.666667"/>
                    </svg>
                </div>
            </div>
        </div>
    )
}
